import { ContentPage } from '@malesia/react-components/dist/src/components/ContentPage/ContentPage';
import { HtmlBlock } from '@malesia/react-components/dist/src/components/Front/HtmlBlock/HtmlBlock';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useIntl } from 'react-intl';
import useSWR from 'swr';
import { loadBaggagePageContent } from '../../services/directus/baggagePage/loadBaggagePageContent';

export const MalesiaBaggagePage: SFC = () => {
    const { locale } = useIntl();
    const { data } = useSWR([locale, 'loadBaggagePageContent'], loadBaggagePageContent);

    return (
        <>
            <ContentPage
                image={data?.topImage}
            >
                <HtmlBlock content={data?.content ?? ''} />
            </ContentPage>
        </>
    );
};
